import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useDeleteWebinar } from '../lib/use-delete-webinar'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'

type DeleteWebinarAlertProps = {
  selectWebinarId: number
  onClose: () => void
}

export const DeleteWebinarAlert: FC<DeleteWebinarAlertProps & AlertDialogProps> = ({
  selectWebinarId,
  onClose,
  ...props
}) => {
  const { isLoadingDelete, handleDeleteWebinar } = useDeleteWebinar()
  const { t } = useTranslation(['webinar'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('webinar:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('webinar:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('webinar:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteWebinar(selectWebinarId, onClose)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('webinar:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
